const actions = {
  GET_CODE_SNIPPET_BEGIN: 'GET_CODE_SNIPPET_BEGIN',
  GET_CODE_SNIPPET_SUCCESS: 'GET_CODE_SNIPPET_SUCCESS',
  GET_CODE_SNIPPET_ERR: 'GET_CODE_SNIPPET_ERR',

  SET_CODE_SNIPPET_BEGIN: 'SET_CODE_SNIPPET_BEGIN',
  SET_CODE_SNIPPET_SUCCESS: 'SET_CODE_SNIPPET_SUCCESS',
  SET_CODE_SNIPPET_ERR: 'SET_CODE_SNIPPET_ERR',

  getCodeSnippetBegin: () => {
    return {
      type: actions.GET_CODE_SNIPPET_BEGIN,
    };
  },

  getCodeSnippetSuccess: data => {
    return {
      type: actions.GET_CODE_SNIPPET_SUCCESS,
      data,
    };
  },

  getCodeSnippetErr: err => {
    return {
      type: actions.GET_CODE_SNIPPET_ERR,
      err,
    };
  },

  setCodeSnippetBegin: () => {
    return {
      type: actions.SET_CODE_SNIPPET_BEGIN,
    };
  },

  setCodeSnippetSuccess: data => {
    return {
      type: actions.SET_CODE_SNIPPET_SUCCESS,
      data,
    };
  },

  setCodeSnippetErr: err => {
    return {
      type: actions.SET_CODE_SNIPPET_ERR,
      err,
    };
  },
};

export default actions;
